import { forwardRef, memo } from "react";

export const HeadphonesIcon = memo(
  forwardRef(function HeadphonesIcon(
    { size = 26, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 17 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          d="M15.75 9.91667V11.5833C15.75 12.964 14.6307 14.0833 13.25 14.0833C11.8693 14.0833 10.75 12.964 10.75 11.5833V9.91667C10.75 8.53595 11.8693 7.41667 13.25 7.41667C14.6307 7.41667 15.75 8.53595 15.75 9.91667ZM15.75 9.91667V8.25C15.75 4.10786 12.3921 0.75 8.25 0.75C4.10786 0.75 0.75 4.10786 0.75 8.25V9.91667M0.75 9.91667V11.5833C0.75 12.964 1.86929 14.0833 3.25 14.0833C4.63071 14.0833 5.75 12.964 5.75 11.5833V9.91667C5.75 8.53595 4.63071 7.41667 3.25 7.41667C1.86929 7.41667 0.75 8.53595 0.75 9.91667ZM15.75 10.75V12.4167C15.75 15.1781 13.5114 17.4167 10.75 17.4167H8.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }),
);

HeadphonesIcon.displayName = "HeadphonesIcon";